<template>
  <div id="badgeModal" class="offcanvas-background">
    <div class="offcanvas offcanvas-right"
         v-click-outside="close">
      <div class="offcanvas-header d-flex align-items-center justify-content-between pb-4">
        <div class="d-flex align-items-center">
          <inline-svg :src="require('@/assets/images/icons/Icon_Badges.svg')"
                      class="mr-3"
                      width="40" height="40"/>
          <span class="font-weight-light" style="font-size: 2.5rem">
            {{$t('app.label.badges')}}
          </span>
        </div>
        <span class="btn btn-xs btn-icon btn-hover-primary ml-auto"
           @click="close">
          <inline-svg :src="require('@/assets/images/icons/Icon_Cancel.svg')"
                      width="20" height="20"/>
        </span>
      </div>
      <div class="offcanvas-content h-100 pb-8">
        <div class="resources-list h-100" >
          <div v-for="glue in badges" :key="glue.name"
               class="flex flex-wrap">
            <h3> {{ glue.name }}</h3>
            <div v-html="unlockedBadge(glue.activatedBadges,glue.badgeCount)"
                 class="pb-3">
            </div>
            <div v-for="badge in glue.badges" :key="badge.id"
                 class="d-flex align-items-center pb-3">
              <img class="cover-fit w-82px h-82px rounded-circle mr-3"
                   :class="{'badge-disabled':badge.activated==='0'}"
                   :src="getBadgeThumbnail(badge.id)"
                   alt="">
              <div class="">
                    <span class="badge-title">
                      {{ badge.badge_name | str_limit(40)}}</span>
                <div>
                  {{ badge.badge_description | str_limit(100)}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HelperMixin from '@/mixins/helperMixin';

export default {
  name: 'SessionBadgesModal',
  mixins: [HelperMixin],
  computed: {
    ...mapGetters(['badges', 'organization']),
  },
  data() {
    return {
      badgeModal: true,
    };
  },
  methods: {
    close() {
      if (document.getElementById('badgeModal').classList.contains('offcanvas-on')) {
        this.$emit('close', { src: 'badges' });
      }
    },
    unlockedBadge(unlocked, all) {
      let message = '';
      message = this.$t('badges.unlocked.text')
        .replace('_UNLOCKED_', unlocked)
        .replace('_ALL_', all);
      return message;
    },
  },
};
</script>

<style scoped>

</style>
